export default __webpack_public_path__ + "static/media/arrow.add24df5.svg";